import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the clients with the filters, the numbers of the platform and the channels */
export const list = data => {
    const uri = `${env.startpoint}/admin/user/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — the whole card of one client */
export const get = data => {
    const uri = `${env.startpoint}/admin/user/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* STATUS — block the account or bring it back, nothing is ever deleted */
export const status = data => {
    const uri = `${env.startpoint}/admin/user/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
